import React, { useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, FolderTree, ShoppingCart, Users, Palette, FileText, LogOut, ExternalLink, Menu, X, Tag, Mail } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useSettings } from "../../context/SettingsContext";
import { imgUrl } from "../../lib/api";

const links = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Επισκόπηση" },
  { to: "/admin/products", icon: Package, label: "Προϊόντα" },
  { to: "/admin/categories", icon: FolderTree, label: "Κατηγορίες" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Παραγγελίες" },
  { to: "/admin/customers", icon: Users, label: "Πελάτες" },
  { to: "/admin/brands", icon: Tag, label: "Μάρκες" },
  { to: "/admin/newsletter", icon: Mail, label: "Newsletter" },
  { to: "/admin/appearance", icon: Palette, label: "Εμφάνιση & Πληροφορίες" },
  { to: "/admin/pages", icon: FileText, label: "Σελίδες" },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const { settings } = useSettings();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); nav("/admin/login"); };

  const SidebarContent = () => (
    <>
      <div className="flex items-center gap-3 px-6 h-20 border-b border-[#2c4d40]">
        <img src={imgUrl(settings?.logo || "/logo.jpeg")} alt="logo" className="h-10 w-10 rounded-md object-cover" />
        <span className="font-serif-display text-lg text-white leading-tight">Διαχείριση</span>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            onClick={() => setOpen(false)}
            data-testid={`admin-nav-${l.to.split("/").pop() || "dashboard"}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${isActive ? "bg-[#CBD9B6] text-[#1E3A2F] font-semibold" : "text-[#CBD9B6] hover:bg-[#2c4d40]"}`}
          >
            <l.icon className="h-4 w-4" /> {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="px-3 py-4 border-t border-[#2c4d40] space-y-1">
        <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm text-[#CBD9B6] hover:bg-[#2c4d40]">
          <ExternalLink className="h-4 w-4" /> Προβολή καταστήματος
        </Link>
        <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm text-[#CBD9B6] hover:bg-[#2c4d40]">
          <LogOut className="h-4 w-4" /> Αποσύνδεση
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex">
      <aside className="hidden lg:flex flex-col w-64 bg-[#1E3A2F] fixed inset-y-0 left-0">
        <SidebarContent />
      </aside>

      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="relative flex flex-col w-64 bg-[#1E3A2F]"><SidebarContent /></aside>
        </div>
      )}

      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden flex items-center justify-between h-16 px-4 bg-[#1E3A2F]">
          <button onClick={() => setOpen(true)} className="text-white"><Menu className="h-6 w-6" /></button>
          <span className="text-white font-serif-display">Διαχείριση</span>
          <button onClick={doLogout} className="text-[#CBD9B6]"><LogOut className="h-5 w-5" /></button>
        </header>
        <main className="p-4 sm:p-8 max-w-6xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
